<template>
  <tr>
    <td style="vertical-align: top;">
      <sui-button v-for="action in actionList" v-bind:content="action" v-on:click="buttonAction(action)"
        v-bind:key="action" />
    </td>
    <td style="vertical-align: top;">
      <pre style="padding: 0px; margin: 0px; white-space: pre-line;">
        <p v-html="newsItem.htmlContent" style="font-family: Lato, Helvetica Neue, Arial, Helvetica, sans-serif; font-size: 16px;" />
      </pre>
    </td>
    <td style="vertical-align: top;">
      <a v-if="newsItem.imageUrl" v-bind:href="newsItem.imageUrl" target="_blank">
        <img v-bind:src="newsItem.imageUrl" style="max-width: 100px; max-height: 100px;" />
      </a>
    </td>
    <td style="vertical-align: top;">{{ newsItem.createdAt }}</td>
    <td style="vertical-align: top;">{{ newsItem.updatedAt }}</td>
  </tr>
</template>

<script>
export default {
  name: 'NewsTableRow',
  props: ['newsItem', 'actions'],
  computed: {
    actionList() {
      return this.actions || [];
    },
  },
  methods: {
    buttonAction(value) {
      this.$emit('action', { action: value, newsItem: this.newsItem });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/news/NewsTableRow.vue